import { useNode } from "@craftjs/core";
import React, { useContext } from "react";

import {
  Tabs,
  PaddingInput,
  MarginInput,
  Spacer,
  TextInput,
  SelectInput,
  Notice,
} from "../../input";

import { supportLibrary } from "../../block-supports";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { Link } from "react-router-dom";
import { isUpdatedFromDefault } from "../../utils";

export const FormGoogleRecaptchaSettings = () => {
  const { project, projectID } = useContext(GrigoraDashboardContext);

  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    layoutMargin,
    layoutMarginTablet,
    layoutMarginMobile,
    layoutPadding,
    layoutPaddingTablet,
    layoutPaddingMobile,
    siteKey,
    secretKey,
  } = props;

  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing={"1rem"}>
          {!project?.forms?.sitekey && (
            <>
              <Notice
                text={
                  <>
                    Google Recaptcha Site Key Not Found. Add it in{" "}
                    <Link
                      target="_blank"
                      to={`/site/${projectID}/settings/forms`}
                    >
                      Form Settings
                    </Link>
                    .
                  </>
                }
                status="warning"
              />
            </>
          )}
          <PaddingInput
            label={"Padding"}
            isResponsive={true}
            value={layoutPadding}
            valueTablet={layoutPaddingTablet}
            valueMobile={layoutPaddingMobile}
            onChange={(val) => {
              setProp((props) => {
                props.layoutPadding = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.layoutPaddingTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.layoutPaddingMobile = val;
              });
            }}
          />
          <MarginInput
            label={"Margin"}
            isResponsive={true}
            valueTablet={layoutMarginTablet}
            valueMobile={layoutMarginMobile}
            value={layoutMargin}
            onChange={(val) => {
              setProp((props) => {
                props.layoutMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.layoutMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.layoutMarginMobile = val;
              });
            }}
          />
        </Spacer>
      </div>
    );
  }

  function AdvancedSettings() {
    return (
      <>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: project },
        { key: layoutPadding },
        { key: layoutPaddingTablet },
        { key: layoutPaddingMobile },
        { key: layoutMarginTablet },
        { key: layoutMarginMobile },
        { key: layoutMargin },
      ]),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
    },
  ];

  return (
    <div>
      <Tabs
        id={`block-settings-tab-${id}`}
        type="block-setting"
        items={tabs.map((item, i) => {
          return {
            label: item.label,
            key: item.key,
            children: item.children,
          };
        })}
      />
    </div>
  );
};
